function formToObject(form) {
    let obj = {}
    let elements = form.querySelectorAll( "input, select, textarea" )
    for( let i = 0; i < elements.length; ++i ) {
        let element = elements[i]
        let name = element.name
        let value = ''

        if (element.type == 'radio') {
            if (element.checked) {
                value = element.value
            } else {
                continue
            }
        } else {
            value = element.value
        }

        if( name ) {
            obj[ name ] = value
        }
    }
    return obj
}

function arrayToFormParams(array) {
    let formData = new URLSearchParams()
    for (const [key, value] of Object.entries(array)) {
        formData.append(key, value)
    }
    return formData
}

export {formToObject, arrayToFormParams}
